import type { ITextReplaceRule } from '@carboncopyco/types';
import type { IFindAndReplaceRuleState } from '../types';
import { CreateControls } from './CreateControls';
import { EditControls } from './EditControls';

export type TextReplaceControlsProps = Pick<
  IFindAndReplaceRuleState<ITextReplaceRule>,
  | 'onSubmit'
  | 'submitting'
  | 'rule'
  | 'rules'
  | 'onCancel'
  | 'autoFocus'
  | 'onFocus'
>;

export const TextReplaceControls = ({
  onSubmit,
  onCancel,
  onFocus,
  rule,
  rules,
  autoFocus,
}: TextReplaceControlsProps) => {
  if (rule) {
    return (
      <EditControls
        onSubmit={onSubmit}
        rule={rule}
        rules={rules}
        onCancel={onCancel}
        onFocus={onFocus}
        autoFocus={autoFocus}
      />
    );
  }

  return (
    <CreateControls
      onSubmit={onSubmit}
      onCancel={onCancel}
      onFocus={onFocus}
      autoFocus={autoFocus}
      rules={rules}
    />
  );
};
